import { useTranslation } from 'react-i18next'

import { Divider, Text } from '@reveni-io/reveni-ui'

import PackagingSelector from '@/common/components/PackagingSelector/PackagingSelector'

import * as Styles from './styles'

const DefaultPackagingSection = ({ packaging, value, onChange }) => {
  const { t } = useTranslation()

  return (
    <Styles.Container>
      <Divider />
      <Text type="titleS">{t('Embalaje por defecto')}</Text>
      <Text type="bodyMRegular">{t('Elige un embalaje por defecto para esta ubicación.')}</Text>
      <PackagingSelector packaging={packaging} value={value} onChange={onChange} />
    </Styles.Container>
  )
}

export default DefaultPackagingSection
